<template>
<div id="q-app">
	<q-layout class="fit">
	<q-splitter v-model="splitterModel" class="fit">
		<template v-slot:before>
			<q-page-container class="fit">
				<q-page class="column fit">
					<q-card class="col column">
						<q-scroll-area class="fit" :visible="true">
							<q-input v-model="pointAddresses[0]" debounce="500" filled label="Откуда"></q-input>
							<q-input v-model="pointAddresses[1]" debounce="500" filled clearable label="Куда (1)"></q-input>
							<q-input v-model="pointAddresses[2]" debounce="500" filled clearable label="Куда (2)"></q-input>

							<p><label class="label">Вид транспорта<br/><select v-model="transportType">
								<option value="truck">Фура</option>
								<option value="fiveton">Пятитонник</option>
								<option value="gazelle">Газель</option>
							</select></label></p>
							<p><label class="label">Способ доставки<br/><select v-model="deliveryType">
								<option value="warehouse">Склад</option>
								<option value="object">Объект</option>
							</select></label></p>
							<p v-if="showInternalInfo"><label class="label">Стоимость рейса<br/><input type="text" step="1000"
								:placeholder="foundRoutes[0]?.cost?.toLocaleString('ru') || ''"
								:value="tripCost != 0? tripCost.toLocaleString('ru'): ''"
								@input="onTripCostInput($event)"
							></label></p>


							<p><label class="label">Стоимость груза<br/>
								<input v-if="transportType === 'truck'" type="text" step="1000"
									:value="cargoCost.toLocaleString('ru')"
									@input="onCargoCostInput($event)"
								>
							</label>
							
							<label v-if="transportType !== 'truck'"><input type="checkbox" v-model="cargoCostAbove4M">от 4 млн ₽</label>
							</p>

							<p v-if="false && foundRoutes[0]?.shoulder !== undefined"><label class="label">Стоимость плеча<br/>
								<input v-if="transportType === 'truck'" type="text" step="1000" disabled
									:value="foundRoutes[0].shoulder.toLocaleString('ru')"
								>
							</label>
							</p>

							<p v-if="routeDistanceKm !== undefined">
								<label class="label">Доставка
								<span style="color: blue" tabindex="0" class="more_info" :title="popupText">(?)</span>
								</label><br/>
								<span class="result">{{ logic.priceToString(deliveryPrices[0]) }}</span><br/>

								<p v-for="r in foundRoutes.slice(1).map((r, i) => ({...r, price: deliveryPrices[1 + i]})).filter(r => r.freeFrom || r.shoulder).slice(0, showInternalInfo? undefined: 1)">
									<label class="label">{{ showInternalInfo? "Сборным рейсом Рязань—" + r.route.replace(/;/g, "—").replace(/</g, ","): "В составе сборного рейса" }}</label><br/>
									<span class="result">{{ logic.priceToString(r.price)/* + (r.shoulder? " (плечо " + r.shoulder + "₽)": "")*/ }}</span>
								</p>
							</p>
							<p class="note">{{ logic.warningText(routeDistanceKm, waypoints) }}</p>
						</q-scroll-area>
					</q-card>
				</q-page>
			</q-page-container>
		</template>

		<template v-slot:after>
			<y-map :pointAddresses="pointAddresses" @waypointsChanged="waypoints = $event" @routeDistanceChanged="routeDistanceKm = $event" class="column">

			</y-map>
		</template>	
	</q-splitter>
	</q-layout>
</div>
</template>

<script setup lang="ts">
import 'quasar/dist/quasar.css';
import '@quasar/extras/material-icons/material-icons.css';
import {useQuasar} from 'quasar';
import {ref, computed} from 'vue';
import YMap from './YMap.vue';

import {Address} from './Logic';
import * as logic from './Logic';

let splitterModel = ref(20);
const q = useQuasar();

function onTripCostInput({target}: Event)
{
	const res = Number(target.value.replace(/[^0-9^\\.\\.]/g, ''));
	tripCost.value = res;
	target.value = res != 0? res.toLocaleString('ru'): '';
}

function onCargoCostInput({target}: Event)
{
	let res = Number(target.value.replace(/[^0-9^\\.\\.]/g, ''));
	cargoCost.value = res;
	target.value = res.toLocaleString('ru');
}

function getShowInternalInfo()
{
	return window.location.hash.includes("showTripCost") || window.location.hash.includes("showInternalInfo");
}

const transportType = ref("truck");
const deliveryType = ref("warehouse");
const tripCost = ref(0);
const showInternalInfo = ref(getShowInternalInfo());
const cargoCost = ref(0);
const cargoCostAbove4M = ref(false);
const routeDistanceKm = ref(undefined);
const waypoints = ref([] as Address[]);
const pointAddresses = ref(["Рязань", "", ""]);
const foundRoutes = computed(() => logic.findRoutes(waypoints.value, logic.transportKindToNumber(transportType.value), deliveryType.value, tripCost.value));

window.addEventListener("hashchange", function() {
	showInternalInfo.value = getShowInternalInfo();
});

function calcPrice(r: logic.RouteCostInfo)
{
	return logic.calcPrice({
		routeDistanceKm: routeDistanceKm.value,
		waypoints: waypoints.value,
		cargoCost: cargoCost.value,
		cargoCostAbove4M: cargoCostAbove4M.value,
		transportType: transportType.value,
		deliveryType: deliveryType.value,
		route: r
	});
}

const deliveryPrices = computed(() => foundRoutes.value.map(r => calcPrice(r)));

const popupText = computed(() => logic.getPopupText({
	transportType: transportType.value,
	deliveryType: deliveryType.value,
	foundRoutes: foundRoutes.value,
	routeDistanceKm: routeDistanceKm.value,
	waypoints: waypoints.value,
	showInternalInfo: showInternalInfo.value
}));
</script>
	
<style scoped>
#q-app {
	height: 100%;
}
#app {
	float: left;
	width: 20%;
	height: 100%;
	font-size: x-large;
}
input, select {
	font-size: large;
}
input[type='checkbox'] {
	width: 20px;
	height: 20px;
}
#map {
	float: left;
	width: 80%;
	height: 100%;
	padding: 0;
	margin: 0;
}
p {
	width: 100%;
	margin: auto;
	text-align: center;
	padding-top: 20px;
}
.note {
	border: 1px solid black;
	padding: 0px;
}
.label {
	margin: auto;
	width: 100%;
	text-align: center;
	font-weight: bold;
}
.result {
	font-size: x-large;
}
@media (pointer: coarse), (hover: none) {
	[title] {
		position: relative;
		display: inline-flex;
		justify-content: center;
		z-index: 1;
	}
	[title]:focus::after {
		content: attr(title);
		position: absolute;
		top: 90%;
		color: black;
		background-color: #eee;
		border: 1px solid;
		width: 250px;
		padding: 2px;
		font-size: medium;
		text-align: left;
	}
}
</style>
